import * as yup from "yup";
const stringOrArraySchema = yup
  .mixed()
  .test("is-valid", "At least one attendee is required", function (value) {
    const { related } = this.parent;

    if (related === "Contact") {
      if (Array.isArray(value)) return value.length > 0;
      return typeof value === "string" && value.trim() !== "";
    }

    return true;
  });

const leadStringOrArraySchema = yup
  .mixed()
  .test("is-valid", "At least one attendee is required", function (value) {
    const { related } = this.parent;

    if (related === "Lead") {
      if (Array.isArray(value)) return value.length > 0;
      return typeof value === "string" && value.trim() !== "";
    }

    return true;
  });
const accountStringOrArraySchema = yup
  .mixed()
  .test("is-valid", "At least one attendee is required", function (value) {
    const { related } = this.parent;

    if (related === "Account") {
      if (Array.isArray(value)) return value.length > 0;
      return typeof value === "string" && value.trim() !== "";
    }

    return true;
  });
const dealStringOrArraySchema = yup
  .mixed()
  .test("is-valid", "At least one attendee is required", function (value) {
    const { related } = this.parent;

    if (related === "Deal") {
      if (Array.isArray(value)) return value.length > 0;
      return typeof value === "string" && value.trim() !== "";
    }

    return true;
  });
export const MeetingSchema = yup.object({
  agenda: yup.string().required("Meeting Name is required"),

  attendes: stringOrArraySchema,
  attendesAccount: accountStringOrArraySchema,
  attendesDeal: dealStringOrArraySchema,
  attendesLead: leadStringOrArraySchema,
  location: yup.string(),
  related: yup.string().required("Related is required"),
  startDate: yup.string().required("Date & Time is required"),
  endDate: yup.string(),
  notes: yup.string(),
  createFor: yup.string(),
  createdBy: yup.string(),
});

export const EditMeetingSchema = yup.object({
  agenda: yup.string().required("Meeting Name is required"),

  attendes: stringOrArraySchema,
  attendesAccount: accountStringOrArraySchema,
  attendesDeal: dealStringOrArraySchema,
  attendesLead: leadStringOrArraySchema,

  location: yup.string(),
  related: yup.string().required("Related is required"),
  startDate: yup.string().required("Date & Time is required"),
  endDate: yup.string(),
  notes: yup.string(),
  createFor: yup.string(),
  createdBy: yup.string(),
});
